/**
 * Types et interfaces pour le moteur de jeu PathBlock
 */

export interface Position {
  row: number;
  col: number;
}

export type WallOrientation = 'horizontal' | 'vertical';

export interface Wall {
  row: number;
  col: number;
  orientation: WallOrientation;
}

export interface Player {
  id: 1 | 2;
  position: Position;
  wallsRemaining: number;
  targetRow: number;
  targetCol: number;
  positionConfirmed: boolean;
  name: string;
}

export type GamePhase = 'waiting' | 'placement' | 'playing' | 'finished';

export interface GameState {
  players: [Player, Player];
  walls: Wall[];
  currentPlayer: 1 | 2;
  phase: GamePhase;
  winner: 1 | 2 | null;
  turnTimeLimit: number | null;
  turnStartTime: number | null;
  lastAction: LastAction | null;
  turnNumber: number;
}

export interface MoveAction {
  type: 'move';
  playerId: 1 | 2;
  to: Position;
}

export interface WallAction {
  type: 'wall';
  playerId: 1 | 2;
  wall: Wall;
}

export type GameAction = MoveAction | WallAction;

export interface LastAction {
  type: 'move' | 'wall';
  playerId: 1 | 2;
  from?: Position;
  to?: Position;
  wall?: Wall;
}

export interface ValidationResult {
  valid: boolean;
  reason?: string;
}

export const BOARD_SIZE = 9;
export const INITIAL_WALLS_PER_PLAYER = 10;
